import * as React from 'react';
import DatePicker from 'react-datepicker';
import { addMinutes } from 'date-fns';
import './react-datepicker.scss';
import { useEffect } from 'react';

export interface IDatePickerAppParam {
  handleChange: Function;
  clear: boolean;
}

const DatePickerApp: React.FC<IDatePickerAppParam> = ({handleChange, clear}): JSX.Element => {
  const [value, setValue] = React.useState<string | null>(null);

  const selected = React.useMemo(() => {
    if (!value) {
      return null;
    }
    const date = new Date(value);
    return addMinutes(date, date.getTimezoneOffset());
  }, [value]);

  const onChange = React.useCallback((newDate: Date | null) => {
    if (!newDate) {
      setValue('');
    } else {
      setValue(addMinutes(newDate, -newDate.getTimezoneOffset()).toISOString());
    }
  }, []);

  useEffect(() => {
    handleChange(value);
  }, [value]);

  useEffect(() => {
    if (clear) {
      setValue('');
    }
}, [clear])

  return (
    <DatePicker
      {...{ selected, onChange }}
      showTimeSelect
      dateFormat="dd/MM/yyyy HH:mm"
    />
  );
}
export default DatePickerApp;
